import axios from "axios";
import makeApiCall from "./axiosIndex";

const contractorsApis = {
  fetchContractor: (): Promise<any> =>
    makeApiCall<any>({ method: "get", url: "/seller/fetchContractor" }),
  deleteContractorById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "delete",
      url: `/seller/deleteContractorById?id=${id}`,
    }),
  createContractor: (data: any): Promise<any> =>
    makeApiCall<any>({ method: "post", url: "/seller/createContractor", data }),
  updateContractorById: (id: any, data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/seller/updateContractorById?id=${id}`,
      data,
    }),
  fetchContractorById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/seller/fetchCOntractorById?id=${id}`,
    }),

  // GSTIN Verification APIs
  // NOTE: /verifyLegalDetails requires a session cookie ("No cookies found."
  // otherwise). It therefore cannot succeed on the public supplier registration
  // page (/public-links/tender/:linkId), which has no session. Needs a public
  // backend variant, as with /tms/tender/verify-public-link.
  verifyGstDetails: (data: {
    orgName: string;
    gstin: string;
  }): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/verifyLegalDetails",
      data,
    }),

  uploadGstFile: async (file: File): Promise<any> => {
    const url = process.env.REACT_APP_GST_URL;
    if (!url) {
      throw new Error(
        "GST extraction service is not configured (REACT_APP_GST_URL is missing from this build)."
      );
    }
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(url, formData);
  },
};

export default contractorsApis;
